// extracted by mini-css-extract-plugin
export default {"rating":"StarsRating_rating__5J7Jz","item":"StarsRating_item__QKQhy"};